
const ImportType = ({row}) => {
  if(row.hasOwnProperty("csv_import_type"))
  {
    return <div><span>{row.csv_import_type.name}</span><br /><span><strong>Context:</strong> {row.csv_import_type.context}</span></div>
  }
}

const UploadedBy = ({row}) => {
  if (row.created_by_user) {
    return <span>{row.created_by_user.first_name} {row.created_by_user.last_name}<br /><small>{row.created_by_user.email}</small></span>
  }
  return <span className="text-muted">Unknown</span>
}

export const IMPORT_LIST_COLUMNS = [
    {
        Header: "#",
        accessor: "id",
        Footer:"#",
        disableFilters:true,
        disableGlobalFilters:true,
        width: 60
        // sticky:'left'
    },
    {
      Header: "Import Type",
      accessor: "csv_import_type_id",
      Cell: ({ row, value }) => <ImportType row={row.original} />,
    },
    {
        Header: "File Name",
        accessor: "name",
        Cell: ({ row, value }) => {
          return <a href={`/import/view/${row.original.id}`}>{value}</a>
          // return <a href={`${process.env.REACT_APP_API_STORAGE_URL}/app/${row.original.path}`}>{value}</a>
        },
    },
    {
        Header: "Rows",
        accessor: "rowcount"
    },
    {
      Header: "Filesize",
      accessor: "size"
    },    
    {
      Header: "Processed?",
      accessor: "is_processed"
    },    
    {
      Header: "Imported?",
      accessor: "is_imported"
    },
    {
        Header: "Uploaded By",
        accessor: "created_by",
        Cell: ({ row }) => <UploadedBy row={row.original} />,
    },
    {
        Header: "Date",
        accessor: "created_at",
        Cell: ({ row, value }) => value,
    },
]
